module.exports = __webpack_public_path__ + "files/3cb7abc1a7c5ead7bb8955b50caf0593.png";